/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { RiskPreset, RiskPreset$inboundSchema } from "./riskpreset.js";

export type RiskPresetsResult = {
  /**
   * Presets in display order.
   */
  presets: Array<RiskPreset>;
};

/** @internal */
export const RiskPresetsResult$inboundSchema: z.ZodMiniType<
  RiskPresetsResult,
  unknown
> = z.object({
  presets: z.array(RiskPreset$inboundSchema),
});

export function riskPresetsResultFromJSON(
  jsonString: string,
): SafeParseResult<RiskPresetsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RiskPresetsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RiskPresetsResult' from JSON`,
  );
}
